import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  Label,
  Input,
} from 'reactstrap';

import SettingsItemTitle from './ItemTitle';

const SettingsItemRekognition = ({
  settingKey,
  setting,
  disabled,
  handleChange,
}) => (
  <Label for={`setting-${settingKey}`} className={classnames('switch', { disabled })} disabled={disabled}>
    <SettingsItemTitle setting={setting} />
    <div className="switch-control input-inner">
      <Input
        type="checkbox"
        name={`setting-${settingKey}`}
        id={`setting-${settingKey}`}
        value={true}
        checked={!!setting.value}
        disabled={disabled}
        onChange={handleChange}
      />
      <i />
    </div>
  </Label>
);

SettingsItemRekognition.propTypes = {
  settingKey: PropTypes.string.isRequired,
  setting: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
};

SettingsItemRekognition.defaultProps = {
  disabled: false,
};

export default SettingsItemRekognition;
